<section class="row table-container text-14 dz-hidden dz-flex-lg">
	<!-- left-table having multiple templates -->
	<div class="col-6 left-table">
		<!-- Used for Browsing Latest Holdings -->
		<ng-container *ngIf="multiRowLeftHeader; else singleRowLeftHeader">
			<table>
				<tr>
					<th class="dummy-portfolio-name-spacer">
						<!-- right side table is 3 times bigger so we need to start with 300% to calculate the equal width -->
						<div [ngStyle]="{ width: enableColumnWidth ? 300 / tableData.cells.length + '%' : '100%' }">
							{{ (tableData?.cells)[0][1] }}
						</div>
					</th>
					<th class="text-bold cell">
						<span dcrHTMLKey="AS_OF_DATE">As of Date</span>
					</th>
				</tr>
				<tr *ngFor="let column of headerColumns; let index">
					<td class="text-bold cell" [class.no-padding-right]="index !== 0">
						<span [dcrHTMLKey]="column['headerDcr']">{{ column['headerFallbackText'] }}</span>
						<icon type="info-circle" class="info-circle" [tooltip]="tooltipInfoBubble"></icon>
						<ng-template #tooltipInfoBubble>
							<section [innerHTML]="holdingsComponentDCR[column.tooltipDcr] | dcr : column.tooltipDcr"></section>
						</ng-template>
					</td>
					<td class="cell">
						<ng-container [ngSwitch]="column.field">
							<span *ngSwitchCase="'targetAllocation'"></span>
							<!-- compositeFee date to be updated -->
							<span *ngSwitchCase="'compositeFee'">{{ dateFormatter.format((tableData?.rows)[0]?.expenseRatioAsOfDate) }}</span>
							<span *ngSwitchDefault>{{ familyAsOf }}</span>
						</ng-container>
					</td>
				</tr>
			</table>
		</ng-container>

		<!-- Used for Browsing Changes to Holdings  -->
		<ng-template #singleRowLeftHeader>
			<table>
				<tr class="heading-cell text-bold cell">
					<ng-container *ngFor="let header of tableData.headersX">
						<th>
							<span>{{ header }}</span>
							<icon *ngIf="header?.formattedValue && infoBubble" type="info-circle" class="info-circle" [tooltip]="infoBubble"></icon>
						</th>
					</ng-container>
				</tr>
			</table>
		</ng-template>
	</div>
	<div class="col-18 right-table dz-flex" #scrollableTable (scroll)="onScroll($event)" [class.min-width-134]="modelIds.length > scrollBreakpoint">
		<table [class.scrolling-table]="modelIds.length > scrollBreakpoint">
			<ng-container *ngFor="let rowIndex of indexes">
				<tr>
					<ng-container *ngFor="let cellRow of tableData.cells; index as cellIndex">
						<td class="cell" [style.width]="100 / tableData.cells.length + '%'" [style.text-align]="numberOfPortfolios === 1 ? 'center' : 'right'">
							<div>
								<span
									class="hover-underline hover-pointer"
									(click)="onClickPortfolio(cellRow)"
									*ngIf="rowIndex === 1 && isPortfolioClickable; else portfolioTextOnly"
									>{{ cellRow[rowIndex] }}</span
								>
								<ng-template #portfolioTextOnly> {{ cellRow[rowIndex] }} </ng-template>
							</div>
						</td>
					</ng-container>
				</tr>
			</ng-container>

			<ng-container>
				<!-- Header rows for target allocation -->
				<tr *ngIf="showTargetAllocation">
					<ng-container *ngFor="let cellRow of tableData.cells; index as cellIndex">
						<td class="cell" [ngClass]="numberOfPortfolios === 1 ? 'text-align-center' : 'text-align-right'">
							<span>{{ cellRow[1] }}</span>
						</td>
					</ng-container>
				</tr>
				<!-- Header rows for latest allocation -->
				<tr *ngIf="showLatestAllocation">
					<ng-container *ngFor="let cellRow of tableData.cells; index as cellIndex">
						<td class="cell" [ngClass]="numberOfPortfolios === 1 ? 'text-align-center' : 'text-align-right'">
							<span>{{ latestAllocationEquitiesRow[cellIndex] }}/{{ latestAllocationFixedIncomeRow[cellIndex] }}</span>
						</td>
					</ng-container>
				</tr>
				<!-- Header rows for composite fee -->
				<tr *ngIf="showCompositeFee">
					<ng-container *ngFor="let cellRow of tableData.cells">
						<td class="cell" [ngClass]="numberOfPortfolios === 1 ? 'text-align-center' : 'text-align-right'">
							<span>{{ cellRow[2] }}</span>
						</td>
					</ng-container>
				</tr>
			</ng-container>
		</table>
	</div>
</section>
<section class="dz-hidden-lg table-container">
	<div class="dz-grid">
		<div class="dz-row margin-bottom-object-2">
			<div class="dz-col-8">
				<dz-select [(value)]="selectedModelPortfolioData.id" (valueChange)="setPortfolioId($event); handleDropDownChange($event)">
					<dz-option *ngFor="let item of tableData['rows']" [value]="item?.id?.formattedValue"> {{ item.name?.formattedValue }} </dz-option>
				</dz-select>
			</div>
			<div class="dz-col-16 dz-text-align-right padding-object-2"><span dcrHTMLKey="FAMILY_AS_OF">As of </span>{{ familyAsOf }}</div>
		</div>
		<ng-container *ngIf="multiRowLeftHeader">
			<div
				*ngFor="let column of headerColumns; let index"
				class="dz-row padding-top-object-0-md"
				[ngClass]="{ 'padding-top-object-3': index === 0, 'padding-top-object-1': index !== 0 }"
			>
				<div class="dz-col-14 dz-col-sm-10 dz-text-12 dz-text-sm-16 text-bold">
					<span class="margin-right-object-2" [dcrHTMLKey]="column['headerDcr']">{{ column['headerFallbackText'] }}</span>
					<icon type="info-circle" class="info-circle" [tooltip]="tooltipInfoBubble"></icon>
					<ng-template #tooltipInfoBubble>
						<section [innerHTML]="holdingsComponentDCR[column.tooltipDcr] | dcr : column.tooltipDcr"></section>
					</ng-template>
				</div>
				<div class="dz-col-6 dz-col-sm-10">
					<span dcrHTMLKey="PORTFOLIO_AS_OF" class="dz-text-16-bold dz-hidden dz-inline-block-sm">As of: </span
					><span>{{ dateFormatter.format((tableData?.rows)[0]?.expenseRatioAsOfDate) }}</span>
				</div>
				<div class="dz-col-4 dz-text-align-right">{{ selectedModelPortfolioData?.[column.field] }}</div>
			</div>
		</ng-container>
	</div>
</section>
